<template>
  <div v-if="point" class="sidebar_content">
    <div class="profile_section">
      <h3 class="profile_name">{{ pointLabel }}</h3>
      <span
        class="profile_badge"
        :class="{ active: point.is_active, inactive: !point.is_active }"
      >
        {{ point.is_active ? $t("STATUS.active") : $t("STATUS.inactive") }}
      </span>
    </div>

    <div class="info_section">
      <div class="info_item">
        <i class="fas fa-building"></i>
        <span class="info_label">{{ $t("PLACEHOLDERS.distribution_point_name") }}</span>
        <span class="info_value">{{ point.distrbution_point_name }}</span>
      </div>

      <div class="info_item">
        <i class="fas fa-phone"></i>
        <span class="info_label">{{ $t("PLACEHOLDERS.mobile") }}</span>
        <span class="info_value">{{ point.mobile }}</span>
      </div>

      <div class="info_item">
        <i class="fas fa-id-card"></i>
        <span class="info_label">{{ $t("PLACEHOLDERS.commercial_registration") }}</span>
        <span class="info_value">{{ point.commercial_registration_number }}</span>
      </div>

      <div class="info_item">
        <i class="fas fa-map-marker-alt"></i>
        <span class="info_label">{{ $t("PLACEHOLDERS.location") }}</span>
        <span class="info_value">{{ point.lat }}, {{ point.lng }}</span>
      </div>

      <div class="info_item">
        <i class="fas fa-calendar"></i>
        <span class="info_label">{{ $t("PLACEHOLDERS.created_at") }}</span>
        <span class="info_value">{{ point.created_at }}</span>
      </div>

      <div class="working_hours_section" v-if="point.working_days_label">
        <h5 class="section_title">
          <i class="fas fa-clock"></i>
          {{ $t("PLACEHOLDERS.working_hours") }}
        </h5>
        <div class="working_info">
          <p>
            <strong>{{ $t("PLACEHOLDERS.working_days") }}:</strong>
            {{ point.working_days_label }}
          </p>
          <p>
            <strong>{{ $t("PLACEHOLDERS.working_hours") }}:</strong>
            {{ point.working_hours_label }}
          </p>
        </div>

        <div
          v-if="point.working_times && point.working_times.length"
          class="working_times_list"
        >
          <div
            v-for="workTime in point.working_times"
            :key="workTime.id"
            class="work_time_item"
            :class="{ active: workTime.is_active }"
          >
            <span class="day_name">{{ $t(`days.${workTime.day}`) }}</span>
            <span class="time_range">{{ workTime.from_at }} - {{ workTime.to_at }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDistributionPointLabel } from "../utils/delegatesMapHelpers";

export default {
  name: "DistributionPointDetailsPanel",

  props: {
    point: {
      type: Object,
      default: null,
    },
  },

  computed: {
    pointLabel() {
      return getDistributionPointLabel(this.point);
    },
  },
};
</script>
